<template>
  <div class="left-chart-4 mt-3 p-2 border card-background">
    <!-- <h3 class="mb-3 font-bold">居民主要疾病-柱状图</h3> -->
    <!-- <dv-decoration-11 style="width: 100%; height: 40px; margin-bottom: 10px"
      >&nbsp; &nbsp;居民主要疾病&nbsp;&nbsp;</dv-decoration-11
    > -->
    <!-- <dv-border-box-13 :color="[$color.borderColor, $color.borderColor]"> -->
    <div class="h-full">
      <div style="width: 100%; padding-top: 0px">
        <ComponentSubtitle
          ><span class="sub-title">服务类别情况</span>
        </ComponentSubtitle>
      </div>
      <div class="w-full">
        <!-- <table style="width: 100%" border="1" cellspacing="1">
          <tr>
            <td></td>
            <td v-for="item in tableData" :key="item.value">{{ item.name }}</td>
          </tr>
          <tr>
            <td>总人次</td>
            <td v-for="item in tableData" :key="item.value">
              {{ item.value }}
            </td>
          </tr>
          <tr>
            <td>占比</td>
            <td v-for="item in tableData" :key="item.value">
              {{ item.scale }}%
            </td>
          </tr>
        </table> -->
        <div id="category-bar" style="width: 100%; height: 220px"></div>
      </div>
    </div>
    <DialogUserTable
      :show.sync="visible"
      :tableData="list"
      @onSelect="onCheckoutItemOfUser"
      :title="title"
      showTitle
    ></DialogUserTable>
    <DialogArchivesCard
      :id="checkUsers.sn"
      :show.sync="visibleArchives"
      @back="visible = true"
    ></DialogArchivesCard>
    <!-- </dv-border-box-13> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
import * as echarts from "echarts";

export default {
  name: "LeftChart3",
  data() {
    return {
      tableData: [],
      visible: false,
      list: [],
      filterList: [],
      visibleArchives: false,
      checkUsers: {},
      title: "",
    };
  },
  components: {
    DialogUserTable,
    DialogArchivesCard,
  },
  computed: {
    ...mapGetters(["globalData", "mapKey", "communityKey", "plotKey"]),
  },
  watch: {
    globalData: {
      handler(n, o) {
        this.$nextTick(() => {
          // this.list = this.globalData["users"] || [];

          this.formatterData();
          this.initChart();
        });
      },
    },
  },
  methods: {
    initChart() {
      let option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          // formatter: function (params) {
          //   return `${params[0].seriesName}${params[0].name} : ${params[0].value}`;
          // }
        },
        xAxis: {
          data: this.tableData.map((v) => v.name),
        },
        grid: {
          left: "2%",
          right: "8%",
          bottom: "25%",
          top: "10%",
          containLabel: true,
        },
        yAxis: {},
        series: [
          {
            type: "bar",
            data: this.tableData.map((v) => v.value),
            barMaxWidth: 55,
            color: "#DFBDBB",
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#333",
                formatter: (val) => {
                  console.log("显示百分比", val);
                  //百分比显示
                  return this.tableData[val.dataIndex].scale + "%";
                },
              },
            },
          },
        ],
      };
      var myChart = echarts.init(document.getElementById("category-bar"));
      myChart.setOption(option);
      myChart.off("click");
      myChart.on("click", (params) => {
        console.log(params);
        this.getCategoryUsers(params.name);
      });
    },
    formatterData() {
      let data = [];
      let sum = 0;
      let orderCategoryCount = this.globalData.orderCategoryCount || {};
      for (let key in orderCategoryCount) {
        sum += orderCategoryCount[key];
        data.push({
          name: key,
          value: orderCategoryCount[key],
        });
      }
      data.forEach((v) => {
        v.scale = Number((v.value / sum) * 100).toFixed(2);
      });
      this.tableData = data;
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visible = false;
      this.visibleArchives = true;
      return;
    },
    getCategoryUsers(category) {
      this.$axios
        .get("/statisticsService/mechanism/order/categoryUsers", {
          params: {
            category,
            subDistrict: this.mapKey,
            community: this.communityKey,
            village: this.plotKey,
          },
        })
        .then((resp) => {
          this.list = resp.data;
          this.visible = true;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
table {
  table-layout: fixed;
  width: 100%;
}
tr {
  width: 100%;
  border: 1px solid black;
}
td {
  border: 1px solid @border-color;
  border-collapse: collapse; /* 移除单元格之间的间隔 */
  // width: 35%;
  text-align: center;
  padding: 6px 8px;
}
.left-chart-4 {
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // background: #fff;
  height: 228px;
  .lc3-header {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    text-indent: 20px;
    margin-top: 10px;
  }

  .lc3-details {
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: @primary-color;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc3-chart {
    flex: 1;
  }
}
</style>
